import { Paper } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import config from '../../config';
import TypingMessage from "../../untils/TypingMessage";
import { zipImages, getRandomId } from '../../untils/until';
import "./Chat.scss";

const Chat = (props: any) => {
  const [messages, setMessages] = useState<any>([]);
  const [input, setInput] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const messageArr = useRef<any>([]);
  const inputRef = useRef(null);
  const { t } = useTranslation();
  const hasDone = useRef(true);
  const sceneSource: any = { 0: { npcImg: 'https://oss.tnworld.cn/eastern/assets/qhc/cici.png', source: 'QINGHUACI' },1: { npcImg: 'https://oss.tnworld.cn/eastern/assets/zgj/npc.png', source: 'ZHONGGUOJIE' },2: { npcImg: 'https://oss.tnworld.cn/eastern/assets/cjy/npc.png', source: 'CUOJINYIN' },3: { npcImg: 'https://oss.tnworld.cn/eastern/assets/jtl/npc.png', source: 'JINGTAILAN' } }
  const [imgName, setImgName] = useState<any>(props.dialogData.imgName);
  const scrollToBottom = () => {
    let bottomElement: any = document.getElementById("chat-box");
    bottomElement.scrollTop = bottomElement.scrollHeight;
  };

  const sessionId = useRef(getRandomId())

  useEffect(() => {
    // 默认显示欢迎语 判断是不是第一次打开
    const str = t('scene_' + props.sceneId + '_npc_desc').split('\n')[0];
    const str1 = t('scene_' + props.sceneId + '_npc_desc').split('\n')[1];
    const str2 = t('scene_' + props.sceneId + '_npc_desc').split('\n')[2];
    if (sessionStorage.getItem("has-open-chat")) {
      let temp: any = [{
        text: str,
        sender: 'bot',
        typing: 1
      }, {
        text: str1,
        sender: 'bot',
        typing: 1
      }, {
        text: str2,
        sender: 'bot',
        typing: 1
      }];
      setMessages(temp);
    } else {
      let obj = {};
      obj = {
        text: str,
        sender: 'bot',
        typing: 2
      }
      let temp: any = [];
      temp[0] = obj;
      setMessages(temp);
      setTimeout(() => {
        obj = {
          text: str1,
          sender: 'bot',
          typing: 2
        }
        temp.push(obj)
        setMessages(temp);

        setTimeout(() => {
          obj = {
            text: str2,
            sender: 'bot',
            typing: 2
          }
          temp.push(obj)
          setMessages(temp);
         sessionStorage.setItem("has-open-chat", 'true');
        }, 3200)
      }, 2100)
    }
  }, [])

  // 关闭弹窗 
  const closeModal = () => {
    window.eventBus.emit('closeNpcChat');
  };

  const handleTypingComplete = (index: any) => {
    if (!hasDone.current) return;
    setIsTyping(false)
    console.log('?????done')
    setMessages((prevMessages: any) => {
      const updatedMessages = [...prevMessages];
      updatedMessages[index].typing = 1;
      return updatedMessages;
    });
  };

  const handleSend = async () => {
    if (isTyping) return;
    if (input.trim()) {
      messageArr.current = [...messages, { text: input, sender: "user", typing: 1 }, { typing: 3, text: 1, sender: 'bot' }]
      setMessages((prevMessages: any) => [
        ...prevMessages,
        { text: input, sender: "user", typing: 1 },
        { typing: 3, text: 1, sender: 'bot' }
      ]);
      setTimeout(() => {
        scrollToBottom()
      }, 100)
      setInput("");
      setIsTyping(true);
      const lan = localStorage.getItem("language") === 'EN' ? 'en' : 'cn'
      const host = config.host
      let eventSource: any = new EventSource(`${host}qwenStream?userMessage=` + input + '&lan=' + lan + '&source=' + sceneSource[props.npcId].source + '&sessionId=' + sessionId.current);
      let messageStr = "";
      const length = messageArr.current.length - 1;
      eventSource.onmessage = function (event: any) {
        hasDone.current = false;
        const data = JSON.parse(event.data);
        const text = data.output.choices[0].message.content
        messageStr += text;

        console.log(text)

        const temp = JSON.parse(JSON.stringify(messageArr.current));
        let obj = {};
        obj = {
          text: messageStr,
          sender: 'bot',
          typing: 2
        }
        temp[length] = obj;
        // 逐字输入 设定一个定时滚动到最底部 在输出后在滚动一次 并清除滚动定时器
        if (data.output.choices[0].finish_reason === 'stop') {
          hasDone.current = true;
          eventSource.close();
        }
        setMessages(temp);
      };
    }
  };


  return (
    <div className="chat-dialog" onClick={closeModal}>
      <div className="close-box" onClick={closeModal}>
        <img src="/assets/images/close-icon.png" alt="" />
      </div>
      <div className={`chat-container ${imgName}`} onClick={(e) => e.stopPropagation()}>
        <div className="virtual" onClick={(e) => e.stopPropagation()} style={{ width: "40vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <img src={zipImages(sceneSource[props.npcId].npcImg)} alt="" />
        </div>
        <div className="messages" id="chat-box">
          {messages.map((message: any, index: any) => {
            let messageContent;

            if (message.typing === 2) {
              messageContent = (
                <TypingMessage
                  message={message.text}
                  answering={() => setIsTyping(true)}
                  onComplete={() => handleTypingComplete(index)}
                  isTyping={isTyping}
                />
              );
            } else if (message.typing === 1) {
              messageContent = message.text;
            } else {
              messageContent = (
                <>
                  <span className="dot">.</span>
                  <span className="dot">.</span>
                  <span className="dot">.</span>
                </>
              );
            }

            return (
              <div className={`message ${message.sender}`} key={index}>
                <Paper className="message-text">
                  {messageContent}
                </Paper>
              </div>
            );
          })}
        </div>
        <div className="input-container">
          <input
            ref={inputRef}
            autoFocus={true}
            value={input}
            onFocus={scrollToBottom}
            onChange={(e) => {
              setInput(e.target.value);
            }}
            onKeyDown={(e) => {
              e.key === "Enter" && handleSend();
            }}
            placeholder={isTyping ? "正在输入..." : "请输入..."}
            autoComplete="off"
            disabled={isTyping}
          />
          <img src="/assets/images/arrow-back.png" onClick={handleSend} className="arrow-back" alt="" />
        </div>
      </div>
    </div>
  );
};

export default Chat;
